<div class="aspect-4/3 overflow-hidden rounded-lg">
  <iframe src="https://www.youtube.com/embed/dQw4w9WgXcQ" title="YouTube video" frameborder="0"
    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen
    class="w-full h-full"></iframe>
</div>